import Layout from '../component/Layout/Layout'
import ShimmerSingleBox from '../component/ShimmerSingleBox';
import { useNewHomeAPI } from '../hooks/useAllCategoryData';
export default function PeopleOfChaashni() {

 /*  const images = [
    {"desktop" : "ch-people3.jpg"},
    {"desktop" : "ch-people4.jpg"},
    {"desktop" : "ch-people5.jpg"},
    {"desktop" : "ch-people6.jpg"},
    {"desktop" : "ch-people7.jpg"},
    {"desktop" : "ch-people13.jpg"},
    {"desktop" : "ch-people14.jpg"},
    {"desktop" : "ch-people15.jpg"},
    {"desktop" : "ch-people17.jpg"},
    {"desktop" : "ch-people19.jpg"},
    {"desktop" : "ch-people20.jpg"},
    {"desktop" : "ch-people22.jpg"},
    {"desktop" : "ch-people25.jpg"},
    {"desktop" : "ch-people27.jpg"},
    {"desktop" : "ch-people29.jpg"},
    {"desktop" : "ch-people30.jpg"},
    {"desktop" : "ch-people32.jpg"},
    {"desktop" : "ch-people35.jpg"}
  ]   */
     
  const { isLoading, error, data } = useNewHomeAPI();
  if (error) return <div>{error.message}</div>;
  return (
    <Layout title="People Of Chaashni : Chaashni Couture" description="Chaashni Couture: People Of Chaashni" > 
        <div className="site-content-wrap static-page mk-page">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">                      
                        <h1 className="sustom-heading-h1">People Of Chaashni</h1>
                        <p>At Chaashni, we’re more than a brand; we’re a diverse family of around 250 artisans, tailors, and hand embroiderers, each bringing their unique skills, culture, and traditions to our creations. </p>
                        <p>We take pride in fostering a work environment where people from different strata of life, religions, and backgrounds come together with dedication and passion. Every dress we create carries the hands and heart of our united team, striving together to craft beauty that resonates with our shared commitment to quality, artistry, and mutual respect.</p>
                        <p>Here are some photos of the talented individuals who bring Chaashni’s creations to life.</p>

                        <div className='people-of-chaashni'>
                            {isLoading && ( <ul><li>
                            {Array.from({ length: 1 }, (_, index) => (
                              <ShimmerSingleBox key={index} CustomStyle={{ height: "600px" }} />
                            ))}
                            </li><li>
                            {Array.from({ length: 1 }, (_, index) => (
                              <ShimmerSingleBox key={index} CustomStyle={{ height: "600px" }} />
                            ))}
                            </li><li>
                            {Array.from({ length: 1 }, (_, index) => (
                              <ShimmerSingleBox key={index} CustomStyle={{ height: "600px" }} />
                            ))}
                            </li>
                          </ul> )}
                          {data?.peopleOfChaashni && (
                          <ul>
                            {data.peopleOfChaashni.map((e,i) => (<li key={i}><img src={`${process.env.REACT_APP_IMAGE_URL}home/people/${e.desktop}`} alt={`${e.desktop}`} /* title={e.desktop} */ /></li>))}                                                   
                          </ul>
                          )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
  )
}